export class UserListItem {
    id: number;
    firstName: string;
    surName: string;
    mail: string;

    public get displayName(): string {
      return `${this.firstName}, ${this.surName} (${this.mail})`;
    }
  
    //Format used for UploadedBy
    public get fullName(): string {
      return `${this.surName} ${this.firstName}`;
    }

    public get fullNameReverse(): string {
      return `${this.firstName} ${this.surName}`;
    }
}
